/**
 * Created by Rodrigo Quesada on 07/01/17.
 */
import {Injectable} from '@angular/core';
import {Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs';
import {FileLocation} from './file-location.class';
import {FileInfo} from '../../../domain/model/common/file/file-info.class';
import {FileService} from './file.service';
import {UserImpersonationService} from '../../../domain/model/user/user-impersonation.service';

@Injectable()
export class FileListService {

    constructor(private readonly _http: Http,
                private readonly _fileService: FileService,
                private readonly _impersonationService: UserImpersonationService) {
    }

    list(location: FileLocation, extraParams?: URLSearchParams): Observable<FileInfo[]> {
        return this._afterRefresh(() => {
            return this._http.get(location.url(), location.httpOptions(extraParams, true))
                .map(res => (res.text().length ? res.json() : []).map(e => new FileInfo(e)));
        });
    }

    download(location: FileLocation, file: FileInfo, extraParams?: URLSearchParams): Observable<boolean> {
        return this._fileService.download(location, this._params(file, extraParams));
    }

    remove(location: FileLocation, file: FileInfo, extraParams?: URLSearchParams): Observable<Response> {
        return this._fileService.remove(location, this._params(file, extraParams));
    }

    private _params(file: FileInfo, extraParams?: URLSearchParams) {
        const params = new URLSearchParams();
        params.set('id', file.id);
        if (extraParams) params.appendAll(params);
        return params;
    }

    private _afterRefresh<R>(body: () => Observable<R>): Observable<R> {
        return this._impersonationService.dataRefreshed$.first().flatMap(body);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/files/service/file-list.service.ts